import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/patient/$patientId/external-records")({
  component: RouteComponent,
});

function RouteComponent() {
  return <div>Hello "/patient/$patientId/external-records"!</div>;
}
